<template>
  <v-app style="background-color:#e0e0e0">
     <div style="margin-top:110px">
       <v-container>
        <v-card>
       <v-container style="padding-top:0px;padding-bottom:0px;">
         <h1>{{destionation.name}}</h1>
         <v-layout row wrap>
                  <v-flex xs12 sm12 md6 style="height:350px;background-size:cover" :style="{backgroundImage: `url(${destionation.src})`}">

                  </v-flex>
                  <v-flex xs12 sm12 md6 style="padding:10px">
                      <h6 class="blue--text">Description</h6>
                      <p>{{destionation.description}}</p>
                      <v-divider style="margin-top:-15px"></v-divider>
                      <h6 class="blue--text">Language</h6>
                      <p>{{destionation.language}}</p>
                      <v-divider style="margin-top:-10px"></v-divider>
                      <v-card-title style="margin-top:-12px">
                          <span>State : <span class="blue--text">{{destionation.state}}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;City : <span class="blue--text">{{destionation.city}}</span>
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;STD Code : <span class="blue--text">{{destionation.stdCode}}</span></span>
                      </v-card-title>
                      <v-divider style="margin-top:-15px"></v-divider>
                      <h6 class="blue--text">Best Time to Visit</h6>
                      <p>{{destionation.bestTime}}</p>
                      <v-divider style="margin-top:-15px"></v-divider>
                      <h6 class="blue--text">Major Festivals:</h6>
                      <p>{{destionation.majorFestival}}</p>
                  </v-flex>


                  <v-flex xs12 sm12 md4 style="text-align:center">
                              <v-icon color="blue">flight</v-icon><p class="grey--text">Nearest Airport</p>
                              <p>{{destionation.nearestAirport}}</p>
                  </v-flex>

                  <v-flex xs12 sm12 md4 style="text-align:center">
                              <v-icon color="blue">directions_subway</v-icon><p class="grey--text">Nearest Rail Station</p>
                              <p>{{destionation.nearestRailStation}}</p>
                  </v-flex>

                  <v-flex xs12 sm12 md4 style="text-align:center">
                              <v-icon color="blue">directions_bus</v-icon><p class="grey--text">Nearest Bus Stop</p>
                              <p>{{destionation.nearestBusStop}}</p>
                  </v-flex>
              </v-layout>
             
       </v-container>
        </v-card>
       </v-container>
     </div>

     <div style="margin:15px">
         <v-layout row wrap>
             <v-flex xs12 sm12 md2 v-for="des in destionation.packages" :key="des.id" style="padding:5px">
               <v-card style="border-radius:0px;padding:0px">
                 <img :src=des.src width="100%" height="220px"/>
                <h5 class="white--text top-left">{{des.name}}</h5>
                <v-card-title>
                  <v-icon :size="18">brightness_4</v-icon>{{des.day}}D/{{des.night}}N
                  <v-spacer></v-spacer>
                  <v-icon :size="20">hotel</v-icon>&nbsp;<v-icon :size="20">drive_eta</v-icon>&nbsp;<v-icon :size="20">filter_hdr</v-icon>
                </v-card-title>

                  <div style="text-align:center">
                    <v-btn
                            small
                            depressed
                            style="background-color:red;"
                            class="white--text"
                            @click="view(des)"
                          >
                            View Details
                          </v-btn>
                  </div>
            </v-card>
           </v-flex>
         </v-layout>
     </div>
    
  </v-app>
</template>

<script>
import config from "./../../config.json";
export default {
  data() {
    return {
      
      destionation: null,
    };
  },

  methods: {
    view(des) {
      sessionStorage.setItem("Detail", JSON.stringify(des));
      this.$router.push("/packageDetails/1"); // + des.id
    },
  },

  mounted() {
    this.axios
        .get(config.API + `Destinations1/${this.$route.params.id}`, {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.destionation = res.data;
          this.$Progress.finish();
        })
        .catch(err => {
          this.$Progress.fail();
        });
    this.$Progress.start();
  }
};
</script>
<style lang="css" scoped>
.banner {
  /* background-image: url('../../assets/places-divider.jpg');
  background-size: cover; */
  /* height:250px; */
  margin-top: -800px;
}
.htg {
  top: -130px;
  position: relative;
}
.lineThrough {
  text-decoration: line-through;
}
.top-left {
  position: absolute;
  top: 8px;
  left: 16px;
}
.tourtheme {
  background-size: cover;
}
.themecap {
  font-family: 'Open Sans', sans-serif;
  padding-top: 130px;
  color: white;
}
.bckclr {
  -webkit-text-fill-color:cornflowerblue
}
.txt_dec:hover {
    text-decoration: none !important;
}
@media screen and (max-width: 768px) {
  .res {
    display: none;
  }
}
@media screen and (min-width: 768px){
  .man {
    display: none;
  }
}
</style>